import { render, staticRenderFns } from "./CurrentProductionStock.vue?vue&type=template&id=bf1227e6&"
import script from "./CurrentProductionStock.vue?vue&type=script&lang=js&"
export * from "./CurrentProductionStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports